module.exports = __webpack_public_path__ + "static/media/galerija_2016 (11).4b21346a.jpg";